// import AOS from "aos";
// import "aos/dist/aos.css";
import layananWorkshop from "../../assets/layanan/layanan-workshop.png";
import layananOperator from "../../assets/layanan/layanan-operator.png";
import layananPengelolaan from "../../assets/layanan/layanan-limbah.png";
import layananKomunitas from "../../assets/layanan/layanan-komunitas.png";

import decoreLayanan from "../../assets/home/decore-layanan-1.png";

import bgLayanan from "../../assets/home/bg-layanan.png";

const Layanan = () => {
  return (
    <>
      <div
        className="bg-light-gray px-6 lg:px-20 pt-14 lg:pb-24 pb-12"
        id="layanan"
      >
        <p
          className="font-bold text-3xl xl:text-4xl font-Rubik text-center mb-12 lg:mb-20 noto-sans"
          data-aos="fade-right"
          data-aos-duration="1500"
          data-aos-offset="800"
        >
          Layanan
        </p>
        <div
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-offset="900"
          className="text-left flex flex-col lg:flex lg:flex-row relative items-center place-content-center justify-center xl:gap-32 gap-20 xl:px-12 open-sans"
        >
          <div className="product-item text-center flex flex-col justify-center items-center relative w-1/2 lg:w-1/6 rounded-3xl shadow-xl mb-6">
            <img
              src={bgLayanan}
              alt=""
              className="absolute -bottom-8 -left-8 -z-50 justify-center items-center"
            />
            <img
              src={layananWorkshop}
              alt="Workshop"
              className="drop-shadow-lg rounded-t-3xl px-8 pt-4 relative justify-center items-center"
            />
            <div className="left-0 w-full bg-white bg-opacity-100 py-6 rounded-b-3xl">
              <p className="text-center text-lg font-semibold">
                Workshop dan
                <br /> Pelatihan
              </p>
            </div>
          </div>

          <div className="product-item text-center flex flex-col justify-center items-center relative w-1/2 lg:w-1/6 rounded-3xl shadow-xl mb-6">
            <img
              src={bgLayanan}
              alt=""
              className="absolute -bottom-8 -left-8 -z-50 justify-center items-center"
            />
            <img
              src={layananOperator}
              alt="Workshop"
              className="drop-shadow-lg rounded-t-3xl px-8 pt-4"
            />
            <div className="left-0 w-full bg-white bg-opacity-100 p-6 rounded-b-3xl">
              <p className="text-center text-lg font-semibold">
                Project
                <br /> Operator
              </p>
            </div>
          </div>

          <div className="product-item text-center flex flex-col justify-center items-center relative w-1/2 lg:w-1/6 rounded-3xl shadow-xl mb-6">
            <img
              src={bgLayanan}
              alt=""
              className="absolute -bottom-8 -left-8 -z-50 justify-center items-center"
            />
            <img
              src={layananPengelolaan}
              alt="Workshop"
              className="drop-shadow-lg rounded-t-3xl px-8 pt-4"
            />
            <div className="left-0 w-full bg-white bg-opacity-100 p-6 rounded-b-3xl">
              <p className="text-center text-lg font-semibold">
                Pengelolaan
                <br /> Limbah
              </p>
            </div>
          </div>

          <div className="product-item text-center flex flex-col justify-center items-center relative w-1/2 lg:w-1/6 rounded-3xl shadow-xl mb-6">
            <img
              src={bgLayanan}
              alt=""
              className="absolute -bottom-8 -left-8 -z-50 justify-center items-center"
            />
            <img
              src={layananKomunitas}
              alt="Workshop"
              className="drop-shadow-lg rounded-t-3xl px-8 pt-4"
            />
            <div className="left-0 w-full bg-white bg-opacity-100 p-6 rounded-b-3xl">
              <p className="text-center text-lg font-semibold">
                Pengembangan
                <br /> Komunitas
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  // AOS.init();
  // AOS.refresh();
  // AOS.refreshHard();
};

export default Layanan;
